
// Cart is disabled — this site uses Amazon/Chewy affiliate links only.
// No Shopify cart needed.

export const useCart = () => {
  return {
    cart: null,
    isLoading: false,
    error: null,
    isOpen: false,
    addToCart: async () => {},
    updateLineQuantity: async () => {},
    removeLine: async () => {},
    openCart: () => {},
    closeCart: () => {},
  };
};